import { Button, Tag, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

// "failed" also covers a marketing email the provider did not confirm, so the header explains it; the icon is
// focusable and named, so the hint reaches keyboard and screen-reader users, and a click on it does not sort
const statusTitle = t => (
    <span>
        {t('columns.status')}{' '}
        <Tooltip title={t('columns.statusHint')} trigger={['hover', 'focus']}>
            <InfoCircleOutlined
                tabIndex={0}
                role="img"
                aria-label={t('columns.statusHint')}
                onClick={event => event.stopPropagation()}
            />
        </Tooltip>
    </span>
);

const antdOrder = order => (order === 'ASC' ? 'ascend' : 'descend');

// the data columns sort on the server (the key is the API's sortField); antd only shows the arrow
const sortable = (key, sort) => ({
    sorter: true,
    sortOrder: sort?.field === key ? antdOrder(sort.order) : null,
});

export const emailLogColumns = (t, onView, sort) => [
    {
        key: 'createdAt',
        title: t('columns.sentAt'),
        ...sortable('createdAt', sort),
        render: (_, row) => dayjs(row.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    { key: 'recipient', title: t('columns.recipient'), dataIndex: 'recipient', ...sortable('recipient', sort) },
    {
        key: 'subject',
        ...sortable('subject', sort),
        title: t('columns.subject'),
        dataIndex: 'subject',
        render: value => (
            <Typography.Text ellipsis={{ tooltip: value }} style={{ maxWidth: 360 }}>
                {value}
            </Typography.Text>
        ),
    },
    {
        key: 'template',
        title: t('columns.template'),
        ...sortable('template', sort),
        render: (_, row) => row.template || '—',
    },
    {
        key: 'status',
        title: statusTitle(t),
        ...sortable('status', sort),
        render: (_, row) => <Tag color={row.status === 'sent' ? 'green' : 'red'}>{t(`status.${row.status}`)}</Tag>,
    },
    {
        key: 'body',
        title: t('columns.body'),
        render: (_, row) => (
            <Button type="link" size="small" onClick={() => onView(row.id)}>
                {t('view')}
            </Button>
        ),
    },
];
